import { IcWord, IcExcel, IcPpt, IcPdf } from "@racoon/icons";

export const getFileIcon = (fileUrl?: string) => {
  if (!fileUrl) return null;

  const extension = fileUrl.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "doc":
    case "docx":
      return IcWord;
    case "xls":
    case "xlsx":
      return IcExcel;
    case "ppt":
    case "pptx":
      return IcPpt;
    case "pdf":
      return IcPdf;
    default:
      return IcWord; // fallback icon
  }
};
